<template>
  <div class="admin-layout">
    <aside class="sidebar">
      <div class="sidebar-logo"><span>🦷</span> 椅旁数字化管理</div>
      <ul class="menu">
        <li
          v-for="item in menuList"
          :key="item.key"
          :class="{ active: activeKey === item.key }"
          @click="activeKey = item.key"
        >
          <span class="menu-icon">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </li>
      </ul>
      <div class="sidebar-footer">椅旁数字化预约系统 v1.0<br />© 2026 技术支持</div>
    </aside>

    <main class="main">
      <header class="header">
        <h3 class="header-title">{{ currentTitle }}</h3>
        <div class="user-wrap" @click.stop="toggleUserMenu">
          <span class="header-avatar">{{ avatarText }}</span>
          <span class="user-name">{{ displayUserName }}</span>
          <div v-if="showUserMenu" class="user-dropdown">
            <div class="dropdown-item" @click.stop="handleLogout">退出登录</div>
          </div>
        </div>
      </header>

      <section class="content">
        <component :is="activePage" />
      </section>
    </main>
  </div>
</template>

<script>
import { getDisplayName } from "@/api/token";
import ChairSettingPage from "./pages/ChairSettingPage.vue";
import SchedulePage from "./pages/SchedulePage.vue";
import ServicePage from "./pages/ServicePage.vue";
import TechPage from "./pages/TechPage.vue";
import OrderList from "./pages/OrderList.vue";
import AllOrderList from "./pages/AllOrderList.vue";
import RepairProject from "./pages/RepairProject.vue";
import HospitalList from "./pages/HospitalList.vue";
import DoctorList from "./pages/DoctorList.vue";

export default {
  name: "AppLayout",
  data() {
    return {
      showUserMenu: false,
      activeKey: "tech",
      menuList: [
        { key: "todo", label: "待办列表", icon: "📋" },
        { key: "allOrders", label: "全部订单", icon: "📄" },
        { key: "tech", label: "技师管理", icon: "👤" },
        { key: "schedule", label: "空闲时间", icon: "📅" },
        { key: "service", label: "服务项目", icon: "⚙️" },
        { key: "device", label: "设备配置", icon: "🖥️" },
        { key: "repair", label: "修复产品", icon: "📦" },
        { key: "hospital", label: "医院列表", icon: "🏥" },
        { key: "doctor", label: "医生列表", icon: "🩺" },
      ],
    };
  },
  mounted() {
    document.addEventListener("click", this.closeUserMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeUserMenu);
  },
  computed: {
    activePage() {
      const pageMap = {
        todo: OrderList,
        allOrders: AllOrderList,
        tech: TechPage,
        service: ServicePage,
        schedule: SchedulePage,
        device: ChairSettingPage,
        repair: RepairProject,
        hospital: HospitalList,
        doctor: DoctorList,
      };
      return pageMap[this.activeKey] || TechPage;
    },
    currentTitle() {
      const current = this.menuList.find((item) => item.key === this.activeKey);
      return current ? current.label : "";
    },
    displayUserName() {
      return getDisplayName();
    },
    avatarText() {
      const name = "管";
      return name;
    },
  },
  methods: {
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    closeUserMenu() {
      this.showUserMenu = false;
    },
    handleLogout() {
      this.showUserMenu = false;
      this.$emit("logout");
    },
  },
};
</script>

<style scoped>
.admin-layout {
  width: 100%;
  height: 100%;
  display: flex;
  background: #f5f7fa;
  overflow: hidden;
}

.sidebar {
  width: 220px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.sidebar-logo {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-logo span {
  font-size: 24px;
}

.menu {
  list-style: none;
  margin: 0;
  padding: 12px 0 0;
  flex: 1;
}

.menu li {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 16px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.menu li:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.menu li.active {
  background: rgba(24, 144, 255, 0.2);
  color: #40a9ff;
  border-right: 3px solid #1890ff;
}

.menu-icon {
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.sidebar-footer {
  padding: 16px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  line-height: 1.7;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.user-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.header-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

.user-dropdown {
  position: absolute;
  right: 0;
  top: 40px;
  min-width: 110px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 10;
}

.dropdown-item {
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  color: #444;
}

.dropdown-item:hover {
  background: #f0f7ff;
  color: #1890ff;
}

.content {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.content::-webkit-scrollbar {
  width: 0;
  height: 0;
}

@media (max-width: 1200px) {
  .sidebar {
    width: 200px;
  }

  .header {
    padding: 0 16px;
  }

  .content {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  .sidebar {
    width: 100%;
  }

  .sidebar-logo {
    padding: 14px 16px;
    font-size: 16px;
  }

  .menu {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0;
  }

  .menu li {
    flex: 0 0 auto;
    height: 42px;
    padding: 0 14px;
    font-size: 13px;
  }

  .menu li.active {
    border-right: none;
    border-bottom: 2px solid #1890ff;
  }

  .sidebar-footer {
    display: none;
  }

  .header {
    height: 52px;
    padding: 0 12px;
  }

  .header-title {
    font-size: 16px;
  }

  .user-name {
    display: none;
  }

  .content {
    padding: 12px;
    overflow: auto;
  }
}
</style>
